import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/icon-right-red.png'
import _imports_1 from '../../assets/images/icon-right-white.png'
import _imports_2 from '../../assets/images/shape-1.png'


const _withScopeId = n => (_pushScopeId("data-v-69d5e226"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "what-we-do-contents",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "100"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "WHAT WE DO"),
  /*#__PURE__*/_createElementVNode("h2", null, "Our Social Media Marketing Process ")
], -1))
const _hoisted_6 = {
  class: "nav nav-tabs what-we-do-tabs d-block",
  id: "myTab",
  role: "tablist",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "200"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "icon-right-red"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
  src: _imports_1,
  alt: "icon-right-white"
}, null, -1))
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = {
  class: "what-we-do-content-right",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "200"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " We are specializes in elevating brands through impactful collaborations. We connect businesses with celebrities and influencers to enhance brand visibility and engagement. ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon-right-red"
}, null, -1))
const _hoisted_14 = {
  class: "tab-content",
  id: "myTabContent",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "300"
}
const _hoisted_15 = { class: "what-we-do-single-items position-relative z-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
  src: _imports_2,
  class: "shape shape-2 position-absolute top-0 end-0",
  alt: "shape"
}, null, -1))
const _hoisted_17 = { class: "icon" }
const _hoisted_18 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "nav-item",
                role: "presentation",
                key: item.id
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link d-flex justify-content-between align-items-center", { active: _ctx.activeIndex === index }]),
                  onClick: ($event: any) => (_ctx.setActive(index))
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.title), 1),
                  _hoisted_8
                ], 10, _hoisted_7)
              ]))
            }), 128))
          ]),
          _createVNode(_component_router_link, {
            to: "/about-us",
            class: "default-btn btn-two",
            "data-aos": "fade-up",
            "data-aos-duration": "1200",
            "data-aos-delay": "300"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" GET YOUR FREE CUSTOM PROPOSAL "),
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_router_link, {
              to: "/about-us",
              class: "read-more"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" KNOW MORE ABOUT US "),
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(['tab-pane', { active: _ctx.activeIndex === index }])
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("img", {
                      title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
                      src: item.image,
                      alt: "icon-diagram2"
                    }, null, 8, _hoisted_18)
                  ]),
                  _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                  _createElementVNode("p", null, _toDisplayString(item.description), 1)
                ])
              ], 2)), [
                [_vShow, _ctx.activeIndex === index]
              ])
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}